import { MilestoneType } from './types';

export const DEFAULT_MILESTONE_TYPE = MilestoneType.FIXED;
